import { Img } from '@chakra-ui/react';
import React, { memo, useMemo } from 'react';

// Move formatDealerName outside component to avoid recreation on each render
const formatDealerName = (name: string): string => {
  if (!name) return '';
  return name
    .toLowerCase()
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// interface Address {
//   street: string;
//   city: string;
//   state: string;
//   zipCode: string;
// }

// interface LicenseType {
//   type: string;
//   badgeClass: string;
// }

// interface WorkingDay {
//   day: string;
//   hours: string;
// }

// interface SocialProfiles {
//   instagram?: string;
//   facebook?: string;
// }

// interface TransferCharges {
//   gun: string;
//   rifle: string;
//   drill: string;
//   nfa: string;
// }

// interface DealerCardProps {
//   // Header
//   headerBgColor: string;
//   premiumTitle: string;
//   isCheckout: boolean;

//   // Body
//   shopType?: string;
//   expeditedProcessing?: string;
//   licenseTypes?: LicenseType[];
//   dealerName: string;
//   address: Address;
//   milesDistance?: string;

//   // Working days
//   isShowWorkingDays?: boolean;
//   workingDays?: WorkingDay[];
//   isSotDealer?: boolean;

//   // Social links
//   showPhone?: boolean;
//   phoneNumbers?: string[];
//   showWebsite?: boolean;
//   website?: string;
//   showInstagram?: boolean;
//   showFacebook?: boolean;
//   socialProfiles?: SocialProfiles;

//   // Rating
//   rating?: string;

//   // Transfer charges (checkout only)
//   transferCharges?: TransferCharges | null;

//   // Attributes (non-checkout only)
//   iconStatus?: string;
//   optStatus?: string;
//   emailIcon?: string;
//   emailStatus?: string;

//   // Button (checkout only)
//   buttonText?: string;
//   buttonTextColor?: string;
//   buttonBorderColor?: string;
// }

const MapDealerCardV2 = ({
  cardData,
  cardWidth,
  idAsParam,
  handleButtonClick,
  onSelectCard,
  actionButtons,
  collapseImageByDefault = false,
}: any) => {
  const {
    headerBgColor,
    premiumTitle,
    isCheckout,
    shopType,
    expeditedProcessing,
    licenseTypes = [],
    dealerName,
    address,
    milesDistance,
    isShowWorkingDays,
    workingDays = [],
    isSotDealer,
    showPhone,
    phoneNumbers = [],
    showWebsite,
    website,
    showInstagram,
    showFacebook,
    socialProfiles = {},
    rating,
    transferCharges = null,
    iconStatus,
    optStatus,
    emailIcon,
    emailStatus,
    buttonText,
    buttonTextColor,
    buttonBorderColor,
    commercial,
    hasRange,
    originalDealerData,
    cardImage,
  } = cardData;

  // Generate unique ID for this card instance - memoized to avoid recalculation
  const cardImageId = useMemo(() => 
    `card-image-${idAsParam || Math.random().toString(36).substr(2, 9)}`,
    [idAsParam]
  );

  // Memoize formatted dealer name to avoid recalculation
  const formattedDealerName = useMemo(() => {
    if (!dealerName) return '';
    return dealerName
      .toLowerCase()
      .split(' ')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }, [dealerName]);

  return (
    <div
      className="dealer-custom-card"
      style={{ width: cardWidth || '312px', minWidth: cardWidth || '312px' }}
      onClick={() => onSelectCard(idAsParam)}
    >
      {/* Header */}
      <div
        className="custom-card-header"
        style={{ backgroundColor: headerBgColor }}
      >
        {premiumTitle && <span className="premium-tag">{premiumTitle}</span>}
        <div className="header-icons">
          {!commercial && (
            <span className="tooltip-container">              
              <Img src='https://assets.masterffl.com/dealerCard/residentialIcon.svg' className='icon-white' height={20} width={20} alt='' />
              <div className="custom-tooltip-box">
                <div className="tooltip-content">
                  <p>This dealer operates in a residential address</p>
                </div>
              </div>
            </span>
          )}
          {commercial && (
            <span className="tooltip-container">             
              <Img src='https://assets.masterffl.com/dealerCard/locationCommercialIcon.svg' className='' height={20} width={20} alt='' />
              <div className="custom-tooltip-box">
                <div className="tooltip-content">
                  <p>This dealer operates in a storefront commercial address</p>
                </div>
              </div>
            </span>
          )}
          {hasRange && (
            <span className="tooltip-container">              
              <Img src='https://assets.masterffl.com/dealerCard/targetRangeIcon.svg' className='icon-white' height={20} width={20} alt='' />

              <div className="custom-tooltip-box">
                <div className="tooltip-content">
                  <p>This has a shooting range</p>
                </div>
              </div>
            </span>
          )}
          {/* {isCheckout && (
            <span className="tooltip-container">
              <img
                src="https://assets.masterffl.com/dealerCard/heartIcon.svg"
                className="white"
                height="20px"
                width="20px"
                alt=""
              />
              <div className="custom-tooltip-box">
                <div className="tooltip-content">
                  <p>Added to your favorites</p>
                </div>
              </div>
            </span>
          )} */}
          <img
            src="https://assets.masterffl.com/dealerCard/arrowIcon.svg"
            className="white toggle-image-btn"
            height="20px"
            width="20px"
            alt=""
            data-image-id={cardImageId}
            data-rotated={collapseImageByDefault ? 'true' : 'false'}
            style={{
              cursor: 'pointer',
              transition: 'transform 0.3s ease',
              transform: collapseImageByDefault ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </div>
      </div>
      <div 
        id={cardImageId}
        className={(cardImage && cardImage !== '' )? 'card-image' : 'card-without-image'}
        style={{ display: collapseImageByDefault ? 'none' : 'flex' }}
      >
        <Img style={{objectFit:"cover"}}
          src={
            (cardImage && cardImage !== '')
              ? cardImage
              : 'https://assets.masterffl.com/dealerCard/street_view.svg'
          }
          alt="Dealer"
        />
      </div>

      {/* Body */}
      <div className="custom-card-body">
        <div className="content-area">
          <div className="shoptype-box">
            {shopType && (
              <div className="custom-shop-type">
                <Img src='https://assets.masterffl.com/dealerCard/shoptypeIcon.svg' className='' height={20} width={20} alt='' />
                &nbsp; {shopType}
              </div>
            )}
            {isCheckout && expeditedProcessing && expeditedProcessing !== '' && (
              <div className="custom-type-flag">
                <Img src='https://assets.masterffl.com/dealerCard/expititedProcessIcon.svg' className='' alt='' />
                {' '}
                {expeditedProcessing}
              </div>
            )}
            {!isCheckout && (
              <div className="counter">
                {licenseTypes.map((license: any, index: any) => (
                  <span key={index} className={`count ${license.badgeClass}`}>
                    {license.type}
                  </span>
                ))}
              </div>
            )}
          </div>
          <div className="custom-title">
            <h2>{formattedDealerName}</h2>
          </div>
          <div className="address-box">
            <div className="custom-address">
              {address?.street} <br />
              {address?.city}, {address?.state}, {address?.zipCode}
            </div>
            {milesDistance && (
              <div className="custom-distance">
                <Img src='https://assets.masterffl.com/dealerCard/locationIcon.svg' className='' height={15} width={15} alt='' />
                {milesDistance?.toLocaleString('en-us', {
                        maximumFractionDigits: 1,
                      })}{' '}miles
              </div>
            )}
          </div>
        </div>
         {isShowWorkingDays || isSotDealer && (<div className="footer-content-area">
          <div className="working-days-box">
            {isShowWorkingDays && (
              <div className="custom-working-days">
                Working Days:{' '}
                <strong className="tooltip-container">
                  Mon - Sat{' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="7"
                    viewBox="0 0 8 7"
                    fill="none"
                  >
                    <path
                      d="M4.22076 5.9375C3.91605 6.46528 3.15427 6.46528 2.84955 5.9375L0.10714 1.1875C-0.197572 0.659723 0.183318 -7.08285e-07 0.792743 -6.55008e-07L6.27757 -1.75509e-07C6.88699 -1.22231e-07 7.26789 0.659722 6.96317 1.1875L4.22076 5.9375Z"
                      fill="#222222"
                    />
                  </svg>
                  <div className="custom-tooltip-box">
                    <div className="tooltip-content working-days">
                      {workingDays.map((day: any, index: any) => (
                        <div key={index} className="working-day-box">
                          <span className="mapday">{day?.day}</span>
                          <span className="maphours">{day?.hours}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </strong>
              </div>
            )}
            {isSotDealer && (
              <span className="nfaBadge tooltip-container">
                NFA
                <div className="custom-tooltip-box">
                  <div className="tooltip-content">
                    <p>This dealers also deals in NFA items</p>
                  </div>
                </div>
              </span>
            )}
          </div>
        </div>)}
        {/* <div className="footer-content-area">
          <div className="working-days-box">
            {isShowWorkingDays && (
              <div className="custom-working-days">
                Working Days:{' '}
                <strong className="tooltip-container">
                  Mon - Sat{' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="7"
                    viewBox="0 0 8 7"
                    fill="none"
                  >
                    <path
                      d="M4.22076 5.9375C3.91605 6.46528 3.15427 6.46528 2.84955 5.9375L0.10714 1.1875C-0.197572 0.659723 0.183318 -7.08285e-07 0.792743 -6.55008e-07L6.27757 -1.75509e-07C6.88699 -1.22231e-07 7.26789 0.659722 6.96317 1.1875L4.22076 5.9375Z"
                      fill="#222222"
                    />
                  </svg>
                  <div className="custom-tooltip-box">
                    <div className="tooltip-content working-days">
                      {workingDays.map((day: any, index: any) => (
                        <div key={index} className="working-day-box">
                          <span className="mapday">{day?.day}</span>
                          <span className="maphours">{day?.hours}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </strong>
              </div>
            )}
            {isSotDealer && (
              <span className="nfaBadge tooltip-container">
                NFA
                <div className="custom-tooltip-box">
                  <div className="tooltip-content">
                    <p>This dealers also deals in NFA items</p>
                  </div>
                </div>
              </span>
            )}
          </div>
        </div> */}

        {/* Footer */}
        {(
        (showPhone && phoneNumbers[0]) ||
        (showWebsite && website) ||
        (showInstagram && socialProfiles?.instagram) ||
        (showFacebook && socialProfiles?.facebook) ||
        (rating && rating !== '0' && rating !== '0.0')
        ) && (
        <div className="custom-footer">
          <div className="custom-socials">
            {showPhone && phoneNumbers[0] && (
              <a href={`tel:${phoneNumbers[0]}`}>
                <Img src='https://assets.masterffl.com/dealerCard/phoneIcon.svg' className='' height={16} width={16} alt='' />
              </a>
            )}
            {showWebsite && website && (
              <a href={website} target="_blank" rel="noopener noreferrer">
                <Img src='https://assets.masterffl.com/dealerCard/globeIcon.svg' className='' height={16} width={16} alt='' />
              </a>
            )}
            {showInstagram && socialProfiles?.instagram && (
              <a
                href={socialProfiles.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img src='https://assets.masterffl.com/dealerCard/instaIcon.svg' className='' height={16} width={16} alt='' />
              </a>
            )}
            {showFacebook && socialProfiles?.facebook && (
              <a
                href={socialProfiles.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img src='https://assets.masterffl.com/dealerCard/facebookIcon.svg' className='' height={16} width={16} alt='' />
              </a>
            )}
          </div>

          {rating && rating !== '0' && rating !== '0.0' && (
            <div className="custom-rating">
              <Img src='https://assets.masterffl.com/dealerCard/ratingicon.svg' className='' height={14} width={14} alt='' />
              {rating}
            </div>
          )}
        </div>
        )} 

        {/* Transfer charge box */}
        {isCheckout && transferCharges && (
          <div className="card-transfer-charge">
            <p className="transfer-charge-title">Transfer charges:</p>
            <div className="transfer-value-box">
              <div className="transfer-value-single">
                <span className="transfer-value-icon">
                  <Img src='https://assets.masterffl.com/dealerCard/gunIcon.svg' className='' alt='' />
                </span>
                <span className="transfer-value">{transferCharges?.gun}</span>
              </div>
              <div className="transfer-value-single">
                <span className="transfer-value-icon">
                  <Img src='https://assets.masterffl.com/dealerCard/rifleIcon.svg' className='' alt='' />
                </span>
                <span className="transfer-value">{transferCharges?.rifle}</span>
              </div>
              <div className="transfer-value-single">
                <span className="transfer-value-icon">
                  <Img src='https://assets.masterffl.com/dealerCard/drillicon.svg' className='' alt='' />
                </span>
                <span className="transfer-value">{transferCharges?.drill}</span>
              </div>
              <div className="transfer-value-single">
                <span className="transfer-value-icon-nfa">NFA</span>
                <span className="transfer-value">{transferCharges?.nfa}</span>
              </div>
            </div>
          </div>
        )}

        {!isCheckout && (
          <div className="attributes360-box">
            <div className="attriute-single">
              <span className="attribute-icon">
                <Img src={iconStatus} className=''  alt='' />
              </span>
              <span className="attribute-text">{optStatus}</span>
            </div>
            <div className="attriute-single">
              <span className="attribute-icon">
                <Img src='https://assets.masterffl.com/dealerCard/transferIcon.svg' className='' alt='' />
              </span>
              <span className="attribute-text">124</span>
            </div>
            <div className="attriute-single">
              <span className="attribute-icon">
                <Img src={emailIcon} className='' alt='' />
              </span>
              <span className="attribute-text">{emailStatus}</span>
            </div>
          </div>
        )}

        {/* Button */}
        {isCheckout && actionButtons && actionButtons.length > 0 && (
          actionButtons.map((button: any, index: number) => (
          <div className="card-button" key={index}>
            <button
              className="custom-button"
              style={{
                color: button?.color ? button?.color : buttonTextColor,
                border: `1px solid ${button?.borderColor ? button?.borderColor : buttonBorderColor}`,
              }}
              id="info-view-btn"
              data-index={index}
              data-value={originalDealerData?.id}
            >
              {button?.label}
            </button>
          </div>
          ))
        )}
      </div>
    </div>
  );
};

// Memoize component to prevent unnecessary re-renders
export default memo(MapDealerCardV2);
